import { useState } from 'react';

import { useWorkspace } from '../../state/workspace.js';
import { UiDocEditor } from './UiDocEditor.js';
import { UI_DOC_EXT } from './ui-doc.js';

/**
 * Shown over the Code tab's text editor while the active tab is a
 * `*.ui.json`: the visual UI document editor, or (in text mode) a button
 * back to it.
 */
export function UiDocOverlay() {
  const active = useWorkspace((s) => s.tabs.at(-1) ?? null);
  const [asText, setAsText] = useState<ReadonlySet<string>>(new Set());
  if (!active || !active.toLowerCase().endsWith(UI_DOC_EXT)) return null;
  const toggle = (text: boolean) =>
    setAsText((prev) => {
      const next = new Set(prev);
      if (text) next.add(active);
      else next.delete(active);
      return next;
    });
  if (asText.has(active)) {
    return (
      <button type="button" className="uied-chip uied-back" onClick={() => toggle(false)}>
        UI editor
      </button>
    );
  }
  return (
    <div className="uied-overlay">
      <UiDocEditor key={active} path={active} onShowText={() => toggle(true)} />
    </div>
  );
}
